define([
	"dojo/_base/declare",
	"csi/state/rootStore",
	"Quality/NewFromTestRun"
], function(declare,{ routerStore },NewFromTestRun) {

	return declare(NewFromTestRun, {
		bSampleContext: true,

		_adjustForm: function(defView) {
			var owner = this.m_cache.getNode(this.getParent().__Parent__, true);
			this._hideFields(defView, this.m_cache, owner);
		},

		/**
		 * @override
		 * Product is actually higher up because this is from Sample
		 */
		onCreatePopupParams: function(params) {
		    params = params || {};
		    params.testRunContextNode = routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Material");
		    params.testRunColor = this.getParent().ProductColor;
		    params.bCanCreateMultipleTestRuns = true;
		}
	});
});